import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-affiliate',
  templateUrl: './affiliate.component.html'
})
export class AffiliateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }




}
